/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  formatDurationClipFormat,
  getBadgeClass,
  getBadgeLabel,
  NEW_EPISODE_BADGE,
  SHOW_STATE_CLIP,
  SHOW_STATE_FREE,
  SHOW_STATE_INFO,
  SHOW_STATE_UPCOMING,
} from 'helpers/BadgeHelper';
import { formatDurationInSeconds } from 'helpers/VideoHelper';

const FIVE_MINUTES = 300000;

const Badge = ({
  theme,
  badge = null,
  liveIndicator = false,
  startDate = null,
  durationInSeconds = 0,
  bookmarkSeconds = 0,
  isHoverStateV2 = false,
  isPoster = false,
  isSeasons = false,
  title = '',
  tabIndex = 0,
}) => {
  const getTimeTillStart = () => (startDate ? new Date(startDate) - new Date() : null);
  const calculateTimeLeft = () => {
    let timeLeft = { minutes: '00', seconds: '00' };
    if (!startDate) return timeLeft;
    timeTillStart = getTimeTillStart();
    if (timeTillStart > 0) {
      timeLeft = {
        minutes: `0${Math.floor((timeTillStart / 1000 / 60) % 60)}`.slice(-2),
        seconds: `0${Math.floor((timeTillStart / 1000) % 60)}`.slice(-2),
      };
    }
    if (timeTillStart < 0) clearInterval(timerInterval);
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [timerInterval, setTimerInterval] = useState(null);

  useEffect(() => {
    if (startDate && badgeLabel === SHOW_STATE_UPCOMING && !timerInterval) {
      setTimerInterval(
        setInterval(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000),
      );
    }
    return () => {
      if (timerInterval) clearInterval(timerInterval);
    };
  }, []);

  if (!badge) return null;
  let timeTillStart = getTimeTillStart();
  let badgeLabel = getBadgeLabel(badge);
  if (badgeLabel === NEW_EPISODE_BADGE) badgeLabel = 'NEW';
  if (badge === SHOW_STATE_FREE) badgeLabel = 'FREE';
  if (badge === SHOW_STATE_CLIP) badgeLabel = formatDurationClipFormat(durationInSeconds);

  if (isHoverStateV2) {
    if ((isPoster && badge === SHOW_STATE_INFO) || badge === SHOW_STATE_CLIP) {
      return null;
    }
    if (badge === SHOW_STATE_INFO) {
      badgeLabel =
        durationInSeconds === bookmarkSeconds
          ? 'WATCHED'
          : `${formatDurationInSeconds(
              durationInSeconds - bookmarkSeconds,
              ' HOUR',
              ' MIN',
              ' SEC',
            )} LEFT`;
    }
    if (badge === SHOW_STATE_UPCOMING) return null;
  }

  const timerComponent = (
    <span>
      {timeLeft.minutes}:{timeLeft.seconds}
    </span>
  );
  const hasTimeLeft = timeLeft.minutes !== '00' && timeLeft.seconds !== '00';
  const badgeClasses = liveIndicator
    ? [(isHoverStateV2 || isSeasons) && theme.hoverStateBadgeV2]
    : [theme.badge, (isHoverStateV2 || isSeasons) && theme.hoverStateBadgeV2];
  const badgeClass = getBadgeClass(badge, theme);
  const isLiveHoverStateV2 = isHoverStateV2 && badge.toLowerCase().replace(/ /g, '') === 'live';
  if (badgeClass) badgeClasses.push(badgeClass);
  if (badge === SHOW_STATE_FREE) badgeClasses.push(theme.badgeFree);
  if (liveIndicator) badgeClasses.push(theme.liveIndicator);
  if (isLiveHoverStateV2) badgeClasses.push(theme.liveHoverV2Badge);
  if (hasTimeLeft && badgeLabel === SHOW_STATE_UPCOMING && timeTillStart < FIVE_MINUTES) {
    return (
      <a className={classNames(badgeClasses, theme.countdown)} role="status">
        Starts in {timerComponent}
      </a>
    );
  }
  return (
    <a className={classNames(badgeClasses)} tabIndex={tabIndex} role="status" aria-hidden="true">
      {badgeLabel}
    </a>
  );
};

Badge.propTypes = {
  badge: PropTypes.string,
  bookmarkSeconds: PropTypes.number,
  durationInSeconds: PropTypes.number,
  isHoverStateV2: PropTypes.bool,
  isPoster: PropTypes.bool,
  isSeasons: PropTypes.bool,
  liveIndicator: PropTypes.bool,
  startDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tabIndex: PropTypes.number,
  theme: PropTypes.shape({}).isRequired,
  title: PropTypes.string,
};
export default Badge;
